// Mini-Modal: Abrechnungs-Override (DCP-2228 follow-up, 19.09.2026)
//
// Bewusst kein CRUD-Formular wie die übrigen Einstellungen-Unterpunkte — nur
// ein einzelner Schalter, kein Bestand zu verwalten. Deshalb ohne eigene
// Route: EventSettingsCard öffnet dieses Modal direkt, statt zu navigieren.

import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { apiClient } from '@/lib/api-client';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Aktuell wirksame Abrechnungsart (inkl. Override), aus GET /api/me. */
  settlementMode?: 'manual' | 'automatic';
}

export function SettlementOverrideDialog({ open, onOpenChange, settlementMode }: Props) {
  const { t } = useTranslation('settings');
  const checked = apiClient.isForcingAutomaticSettlement();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('settlementOverride.title')}</DialogTitle>
          <DialogDescription>{t('settlementOverride.description')}</DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <Switch
              checked={checked}
              onCheckedChange={(v) => {
                // Wie beim Rollenwechsel (StagingRoleSwitcher): ein voller Reload
                // ist die einfachste, mit dem bestehenden Muster konsistente Art,
                // jede vom Override abhängige Anzeige (Quick-Actions, Wizard) neu
                // aus dem Server zu laden.
                apiClient.setForceAutomaticSettlement(v);
                window.location.reload();
              }}
            />
            <label className="text-sm font-medium">
              {checked ? t('settlementOverride.switchOn') : t('settlementOverride.switchOff')}
            </label>
          </div>
          {settlementMode && (
            <p className="text-xs text-muted-foreground">
              {t('settlementOverride.currentMode', {
                mode: t(`settlementOverride.mode${settlementMode === 'automatic' ? 'Automatic' : 'Manual'}`),
              })}
            </p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('settlementOverride.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
